<template>
  <div class="step-panel" data-testid="payroll-step6-confirmation">
    <h3>{{ t('Confirmation') }}</h3>

    <div v-if="isProcessing" class="loading-container">
      <spinner />
      <p>{{ t('Processing payroll period...') }}</p>
    </div>

    <div v-else-if="isComplete" class="success-state">
      <i class="pi pi-check-circle"></i>
      <h3>{{ t('Payroll Period Calculated Successfully') }}</h3>
      <p>{{ t('The payroll period has been calculated and is ready for payment') }}</p>

      <div class="success-actions p-mt-3">
        <Button
          :label="t('Ver detalhes do período')"
          icon="pi pi-eye"
          data-testid="payroll-step6-view-details-btn"
          @click="handleViewDetails"
        />
        <Button
          :label="t('Voltar ao painel')"
          icon="pi pi-arrow-left"
          class="p-button-secondary"
          data-testid="payroll-step6-back-dashboard-btn"
          @click="handleBackToDashboard"
        />
      </div>
    </div>

    <div v-else class="confirmation-message">
      <inline-message severity="warn" :closable="false">
        {{ t('Por favor revise todas as informações antes de finalizar o cálculo da folha') }}
      </inline-message>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

interface Props {
  isProcessing?: boolean;
  isComplete?: boolean;
}

withDefaults(defineProps<Props>(), {
  isProcessing: false,
  isComplete: false,
});

const emit = defineEmits<{
  'view-details': [];
  'back-to-dashboard': [];
}>();

const { t } = useI18n();

const handleViewDetails = (): void => {
  emit('view-details');
};

const handleBackToDashboard = (): void => {
  emit('back-to-dashboard');
};
</script>

<style scoped>
.step-panel {
  width: 100%;
}

.step-panel h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.loading-container,
.success-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  gap: 1rem;
}

.success-state i {
  font-size: 4rem;
  color: var(--green-500);
}

.success-state h3 {
  margin: 0;
  color: var(--text-color);
}

.success-actions {
  display: flex;
  gap: 1rem;
}

.confirmation-message {
  padding: 2rem;
}
</style>
